import { DesktopTimePicker, TabContext, TabList, TimePicker } from '@mui/lab';
import { MobileTimePicker } from '@mui/x-date-pickers/MobileTimePicker';
import { Autocomplete, Box, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, FormGroup, Grid, IconButton, Radio, RadioGroup, Switch, Tab, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import AutoCompleteMultiSelect from '../../../components/AutoCompleteMultiselect/AutoCompleteMultiSelect.tsx';
import TextAreaComponents from '../../../components/TextAreaComponents/TextAreaComponents.tsx';
import CancelIcon from '@mui/icons-material/Cancel'
import galleryIcon from './../../../../assets/icons/gallery.png'
import plusIcon from './../../../../assets/icons/plus.png'
import Cancel from './../../../../assets/icons/close.png'

function AddRecommendedItemForHomePageDialog(props) {
    const [value, setValue] = React.useState('1')
    const [switchCheck, setswitchCheck] = useState(false)
    const [isChain, setisChain] = useState(false)
    const [defaultvalue, setDefaultvalue] = useState({})
    // const { title } = props.title
    //Addsection dialog control start
    const [openAddKeyword, setOpenAddKeyword] = useState(false)

    const [openAddSection, setOpenAddSection] = useState(false);
    const [dialogType, setDialogType] = useState('');

    const handleClickOpen = () => {
        setOpenAddSection(true);
        setDialogType('add');
    }
    const handleClickOpenOk = () => {
        setOpenAddSection(true);
        setDialogType('sub');
    }
    const handleClickKeyword = () => {
        setOpenAddKeyword(true)
    }
    const handleAddItem = (AddSectionData) => {
        setOpenAddSection(AddSectionData)
    }

    const handleKeywordDialog = (KeywordDialog) => {
        setOpenAddKeyword(KeywordDialog)
    }
    //AddSpecification modal open functionality
    const [open, setOpen] = useState(false)

    const handleOpen = () => {
        setOpen(true)
    }

    const handleCloseSpecifications = () => {
        setOpen(false)
    }
    //Addsection dialog controll end

    //image upload code start

    const [state, setState] = useState<ImageUploadState>({
        selectedImages: [],
    })

    const handleImageUpload = (event: ChangeEvent<HTMLInputElement>) => {
        const files = event.target.files
        if (files) {
            const imagesArray: string[] = []
            const remainingSlots = 5 - state.selectedImages.length
            const filesToUpload = Array.from(files).slice(0, remainingSlots)
            for (let i = 0; i < filesToUpload.length; i++) {
                const file = filesToUpload[i]
                const reader = new FileReader()
                reader.onloadend = () => {
                    imagesArray.push(reader.result as string)
                    if (imagesArray.length === filesToUpload.length) {
                        const updatedImages = [...state.selectedImages, ...imagesArray]
                        setState({ selectedImages: updatedImages })
                    }
                }
                reader.readAsDataURL(file)
            }
        }
    }

    const handleDeleteImage = (index: number) => {
        const updatedImages = [...state.selectedImages]
        updatedImages.splice(index, 1)
        setState({ selectedImages: updatedImages })
    }
    //image upload code end

    const handleSwitchChange = () => {
        setswitchCheck(!switchCheck)
    }

    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
        setValue(newValue)
    }
    const handleClose = () => {
        props.onHandleAddItem(false)
    }
    const [autoCompleteValue, setAutoCompleteValue] = React.useState([])
    const [specificationRows, setSpecificationRows] = React.useState([])
    const handleAddSpecification = (newSpecification) => {
        // Add the new specification to the existing rows data
        setSpecificationRows((prevRows) => [...prevRows, newSpecification])
    }
    const Menudata = [
        { id: 1, title: 'In Store Menu' },
        { id: 2, title: 'Online' },
        { id: 3, title: 'Offer' },
    ]
    useEffect(() => {
        if (props.title === 'Offers') {
            setDefaultvalue(Menudata[2])
        } else if (props.title === 'Online') {
            setDefaultvalue(Menudata[1])
        } else {
            setDefaultvalue(Menudata[0])
        }
    }, [props])
    const sectionDatas = [
        { id: 1, title: 'Italian' },
        { id: 2, title: 'British' },
        { id: 3, title: 'Chinese' }
    ]
    const ManagerDatas = [
        { id: 1, title: 'Leo' },
        { id: 2, title: 'Sunbeam' }
    ]
    const discountDatas = [
        { id: 1, title: 'Discount 1' },
        { id: 2, title: 'Discount 2' }
    ]
    const restaurantDatas = [
        { id: 1, title: 'PKB london' },
        { id: 2, title: 'PKB Manchester' },
    ]
    const vatDatas = [
        { id: 1, title: '%' },
        { id: 2, title: 'Taka' }
    ]
    const itemType = [
        { id: 1, title: 'Chicken' },
        { id: 2, title: 'Burger' },
        { id: 3, title: 'Curry' },
        { id: 4, title: 'Soup' },
        { id: 5, title: 'Fries' },
    ]


    const addValue = (props) => {
        console.log(props)
        setAutoCompleteValue(props)
    }

    const textFieldValue = (props) => {
        console.log(props)
        setAutoCompleteValue(props)
    }
    const [priceExclusive, setPriceExclusive] = useState(0);
    const setpriceExclusiveval = (props) => {
        console.log(props)
        setPriceExclusive(props)
    }

    const [vatAmount, setVatAmount] = useState(0);
    const [vatInAmount, setvatInAmount] = useState(0);
    const [priceInclusive, setpriceInclusive] = useState(0);
    const inAmountVATValue = (props) => {
        console.log(props)
        var Vatprice = props * 100;
        var total = Vatprice / priceExclusive;
        setvatInAmount(total)
        setVatAmount(props);
        setpriceInclusive(parseInt(priceExclusive) + parseInt(total));
    }
    const [selectDay, setSelectDay] = useState(true);
    const [mselectDay, setMSelectDay] = useState(true);
    const [TselectDay, setTSelectDay] = useState(true);
    const [WselectDay, setWSelectDay] = useState(true);
    const [T1selectDay, setT1SelectDay] = useState(true);
    const [FselectDay, setFSelectDay] = useState(true);
    const [SselectDay, setSSelectDay] = useState(true);

    const inPercentageVATValue = (props) => {
        console.log(props)
        var Vatprice = props / 100;
        var total = Vatprice * priceExclusive;
        setVatAmount(total)
        setvatInAmount(props);
        setpriceInclusive(parseInt(priceExclusive) + parseInt(total));
    }
    const [radiovalue, setRadioValue] = React.useState('Specify');
    const [isactive, setIsactive] = React.useState(false);
    const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRadioValue((event.target as HTMLInputElement).value);
        console.log("radiovalue: " + (event.target as HTMLInputElement).value);

    };
    return (
        <>
            <div>
                <React.Fragment>
                    <Dialog
                        fullWidth={true}
                        maxWidth={'xl'}
                        open={props.open}
                        onClose={handleClose}
                    >
                        <Grid container>
                            <Grid item xs={6}>
                                <DialogTitle>Add Recommended To Home Page</DialogTitle>
                            </Grid>
                            <Grid item xs={6}>
                                <DialogActions>
                                    <Button onClick={handleClose}>
                                        <img src={Cancel} alt="Close" style={{ width: '1.2rem' }} />
                                    </Button>
                                </DialogActions>
                            </Grid>
                        </Grid>
                        <DialogContent>
                            <div style={{ padding: "10px" }}>
                                <Grid container sx={{ padding: '0.5rem' }}>
                                    <Grid item xs={2}>
                                        <Typography style={{ paddingTop: '1rem' }}>
                                            Restaurant Name
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={10}>
                                        <AutoCompleteMultiSelect
                                            label={'Restaurant Name'}
                                            placeholder={'Restaurant Name'}
                                            value={addValue}
                                            datas={restaurantDatas}
                                            id={1}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container sx={{ padding: '0.5rem' }}>
                                    <Grid item xs={2}>
                                        <Typography style={{ paddingTop: '1rem' }}>
                                            Item Name
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={10}>
                                        <AutoCompleteMultiSelect
                                            label={'Item Name'}
                                            placeholder={'Item Name'}
                                            value={addValue}
                                            datas={itemType}
                                            id={1}
                                        />
                                    </Grid>
                                </Grid>

                                <Grid container sx={{ padding: '0.5rem' }}>
                                    <Grid item xs={2}>
                                        <Typography style={{ paddingTop: '1rem' }}>
                                            Is Active
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={9}>
                                        <Switch
                                            checked={isChain}
                                            onChange={() => { setisChain(!isChain) }}
                                            inputProps={{ 'aria-label': 'controlled' }}
                                        />
                                    </Grid>
                                </Grid>


                                <Grid container sx={{ padding: '0.5rem' }}>
                                    <Grid item xs={2}>
                                        <Typography style={{}}>
                                            Timing
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={10}>
                                        <Grid container>
                                            <Grid item xs={12}>
                                                <div className='d-flex' style={{ gap: "10px", flexDirection: "column" }}>
                                                    <div className='d-flex' style={{ gap: "10px" }}>
                                                        <button className={` circleBtn ${selectDay ? "colorNotSelected" : "colorSelected"} `} onClick={() => { setSelectDay(!selectDay) }}>
                                                            S
                                                        </button>
                                                        <button className={` circleBtn ${mselectDay ? "colorNotSelected" : "colorSelected"} `} onClick={() => { setMSelectDay(!mselectDay) }}>
                                                            M
                                                        </button>
                                                        <button className={` circleBtn ${TselectDay ? "colorNotSelected" : "colorSelected"} `} onClick={() => { setTSelectDay(!TselectDay) }}>
                                                            T
                                                        </button>
                                                        <button className={` circleBtn ${WselectDay ? "colorNotSelected" : "colorSelected"} `} onClick={() => { setWSelectDay(!WselectDay) }}>
                                                            W
                                                        </button>
                                                        <button className={` circleBtn ${T1selectDay ? "colorNotSelected" : "colorSelected"} `} onClick={() => { setT1SelectDay(!T1selectDay) }}>
                                                            T
                                                        </button>
                                                        <button className={` circleBtn ${FselectDay ? "colorNotSelected" : "colorSelected"} `} onClick={() => { setFSelectDay(!FselectDay) }}>
                                                            F
                                                        </button>
                                                        <button className={` circleBtn ${SselectDay ? "colorNotSelected" : "colorSelected"} `} onClick={() => { setSSelectDay(!SselectDay) }}>
                                                            S
                                                        </button>
                                                    </div>
                                                    <RadioGroup
                                                        row
                                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                                        name="row-radio-buttons-group"
                                                        value={radiovalue}
                                                        onChange={handleRadioChange}
                                                    >
                                                        <FormControlLabel value="24/7" control={<Radio />} label="24/7" />
                                                        <FormControlLabel value="Closed" control={<Radio />} label="Closed" />
                                                        <FormControlLabel value="Specify" control={<Radio />} label="Specify" />
                                                    </RadioGroup>
                                                    <div className={`d-flex ${radiovalue === "Specify" ? "" : "disabledifClose"} `} style={{ gap: "10px" }}>
                                                        <Typography style={{}}>
                                                            From
                                                        </Typography>
                                                        <input type="time" id="appt" name="appt" className='form-control' />
                                                        <Typography style={{}}>
                                                            To
                                                        </Typography>
                                                        <input type="time" id="appt" name="appt" className='form-control' />
                                                    </div>

                                                </div>

                                            </Grid>
                                        </Grid>

                                    </Grid>
                                </Grid>

                                <Grid container sx={{ padding: '0.5rem' }}>
                                    <Grid item xs={10}></Grid>
                                    <Grid item xs={2}>
                                        <Button className="AddItemButtons">Save</Button>
                                    </Grid>
                                </Grid>
                            </div>
                        </DialogContent>

                        {/* <DialogActions>
            <Button onClick={handleClose}>Close</Button>
          </DialogActions> */}
                    </Dialog>
                </React.Fragment>
            </div>
        </>
    )
}

export default AddRecommendedItemForHomePageDialog;